import {useEffect} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {DownloadIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useOnScreenObserver} from "../../atoms/chat_bot/feedback_popup/hooks/use_on_screen_observer";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {useVendorReportButton} from "../../vendor/hooks/use_vendor_report_button";
import {hitGTMDeveloperReportView} from "../../vendor/tracking/hit_gtm_developer_report";
import {VENDOR_REPORT_SECTION_ID} from "../constants/vendor_report_section";

const reportImage = require("../images/report.png");

interface Props {
    vendorId: number;
    propertyId: number;
    offerId: number;
}

export function PropertyDetailVendorReportSection(props: Props) {
    const {vendorId, propertyId, offerId} = props;
    const {isMobile} = useUserDevice();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {handleClick, buttonText} = useVendorReportButton(vendorId, {propertyId, offerId, amplitudePlacement: "rp_download_developer_report_property"});
    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(VENDOR_REPORT_SECTION_ID);

    useEffect(() => {
        startObserver();
    }, []);

    useEffect(() => {
        if (isOnScreen) {
            hitGTMDeveloperReportView();
            stopObserver();
        }
    }, [isOnScreen]);

    const reportSectionStyle = isUserAuthenticated
        ? cx(sectionWrapper, css({backgroundColor: "var(--colors-success)"}))
        : cx(sectionWrapper, css({backgroundColor: "#FFF"}));

    return (
        <div className={reportSectionStyle}>
            <Image width="210px" height="204px" alt="" src={reportImage} className={imageStyle} />

            <div className={textWrapper}>
                <Text variant="headline_4" as="p" mb={1.5} align={isMobile ? "center" : "start"}>
                    Raport o deweloperze
                </Text>
                <Text variant="body_copy_1" mb={1.5} align={isMobile ? "center" : "start"}>
                    Poznaj dewelopera bliżej! Pobierz raport, w którym znajdziesz kluczowe informacje o firmie, jej doświadczeniu, nagrodach oraz aktualnych i
                    zrealizowanych inwestycjach.
                </Text>

                <Button
                    variant="outlined_secondary"
                    size="medium"
                    iconLeft={DownloadIcon}
                    className={buttonStyle}
                    onClick={handleClick}
                    dataTestId={OFFER_TEST_IDS.PROPERTY_VIEW.VENDOR_REPORT_BUTTON}
                >
                    {buttonText}
                </Button>
            </div>
        </div>
    );
}

const sectionWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: 2,
    mb: 2,
    borderRadius: 2,
    gap: 2,

    md: {
        flexDirection: "row",
        alignItems: "start",
        p: 3,
        mb: 3,
        gap: 4
    }
});

const textWrapper = css({
    textAlign: "center",

    md: {
        textAlign: "start"
    }
});

const imageStyle = css({
    minWidth: "210px"
});

const buttonStyle = css({
    minWidth: "200px",
    mt: 1.5,

    md: {
        mt: 0
    }
});
import {useEffect} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {DownloadIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useOnScreenObserver} from "../../atoms/chat_bot/feedback_popup/hooks/use_on_screen_observer";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {useVendorReportButton} from "../../vendor/hooks/use_vendor_report_button";
import {hitGTMDeveloperReportView} from "../../vendor/tracking/hit_gtm_developer_report";
import {VENDOR_REPORT_SECTION_ID} from "../constants/vendor_report_section";

const reportImage = require("../images/report.png");

interface Props {
    vendorId: number;
    propertyId: number;
    offerId: number;
}

export function PropertyDetailVendorReportSection(props: Props) {
    const {vendorId, propertyId, offerId} = props;
    const {isMobile} = useUserDevice();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {handleClick, buttonText} = useVendorReportButton(vendorId, {propertyId, offerId, amplitudePlacement: "rp_download_developer_report_property"});
    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(VENDOR_REPORT_SECTION_ID);

    useEffect(() => {
        startObserver();
    }, []);

    useEffect(() => {
        if (isOnScreen) {
            hitGTMDeveloperReportView();
            stopObserver();
        }
    }, [isOnScreen]);

    const reportSectionStyle = isUserAuthenticated
        ? cx(sectionWrapper, css({backgroundColor: "var(--colors-success)"}))
        : cx(sectionWrapper, css({backgroundColor: "#FFF"}));

    return (
        <div className={reportSectionStyle}>
            <Image width="210px" height="204px" alt="" src={reportImage} className={imageStyle} />

            <div className={textWrapper}>
                <Text variant="headline_4" as="p" mb={1.5} align={isMobile ? "center" : "start"}>
                    Raport o deweloperze
                </Text>
                <Text variant="body_copy_1" mb={1.5} align={isMobile ? "center" : "start"}>
                    Poznaj dewelopera bliżej! Pobierz raport, w którym znajdziesz kluczowe informacje o firmie, jej doświadczeniu, nagrodach oraz aktualnych i
                    zrealizowanych inwestycjach.
                </Text>

                <Button
                    variant="outlined_secondary"
                    size="medium"
                    iconLeft={DownloadIcon}
                    className={buttonStyle}
                    onClick={handleClick}
                    dataTestId={OFFER_TEST_IDS.PROPERTY_VIEW.VENDOR_REPORT_BUTTON}
                >
                    {buttonText}
                </Button>
            </div>
        </div>
    );
}

const sectionWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: 2,
    mb: 2,
    borderRadius: 2,
    gap: 2,

    md: {
        flexDirection: "row",
        alignItems: "start",
        p: 3,
        mb: 3,
        gap: 4
    }
});

const textWrapper = css({
    textAlign: "center",

    md: {
        textAlign: "start"
    }
});

const imageStyle = css({
    minWidth: "210px"
});

const buttonStyle = css({
    minWidth: "200px",
    mt: 1.5,

    md: {
        mt: 0
    }
});
